/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type InspirationQueryVariables = Types.Exact<{
    input: Types.DiscoverDesignsInput;
}>;

export type InspirationQuery = {
    __typename: 'Query';
    discoverDesigns: {
        __typename: 'DiscoverDesigns';
        designs: Array<{
            __typename: 'Design';
            image: string;
            designer: { __typename: 'User'; id: string; displayName: string };
        }>;
    };
};

export const InspirationDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Inspiration' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'DiscoverDesignsInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discoverDesigns' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designs' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                arguments: [
                                                    {
                                                        kind: 'Argument',
                                                        name: { kind: 'Name', value: 'size' },
                                                        value: {
                                                            kind: 'EnumValue',
                                                            value: 'MEDIA',
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'designer' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'id' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'displayName',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type InspirationComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<InspirationQuery, InspirationQueryVariables>,
    'query'
> &
    ({ variables: InspirationQueryVariables; skip?: boolean } | { skip: boolean });

export const InspirationComponent = (props: InspirationComponentProps) => (
    <ApolloReactComponents.Query<InspirationQuery, InspirationQueryVariables>
        query={InspirationDocument}
        {...props}
    />
);

/**
 * __useInspirationQuery__
 *
 * To run a query within a React component, call `useInspirationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspirationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspirationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInspirationQuery(
    baseOptions: Apollo.QueryHookOptions<InspirationQuery, InspirationQueryVariables>
) {
    return Apollo.useQuery<InspirationQuery, InspirationQueryVariables>(
        InspirationDocument,
        baseOptions
    );
}
export function useInspirationLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<InspirationQuery, InspirationQueryVariables>
) {
    return Apollo.useLazyQuery<InspirationQuery, InspirationQueryVariables>(
        InspirationDocument,
        baseOptions
    );
}
export type InspirationQueryHookResult = ReturnType<typeof useInspirationQuery>;
export type InspirationLazyQueryHookResult = ReturnType<typeof useInspirationLazyQuery>;
export type InspirationQueryResult = Apollo.QueryResult<
    InspirationQuery,
    InspirationQueryVariables
>;
